module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_vm._v("Published in 2015 by Chronicle Books LLC."), _c('br'), _vm._v("All rights reserved. No part of this book may be reproduced"), _c('br'), _vm._v("in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("Material on "), _c('span', {
    attrs: {
      "href": "#/xhtml/06chapter01#page_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 6")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/07chapter02#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter04#page_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/10chapter05#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/24chapter19#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/27chapter22#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/xhtml/30chapter25#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/30chapter25#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" previously published in "), _c('em', [_vm._v("Picnics")]), _c('br'), _vm._v("by Sara Dressen (text copyright © 2004 by Chronicle Books LLC and photographs copyright ©2004 by Jonelle Weaver) by Chronicle Books LLC.")]), _vm._v(" "), _c('p', [_vm._v("Material on "), _c('span', {
    attrs: {
      "href": "#/xhtml/08chapter03#page_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 10")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/08chapter03#page_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11chapter06#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter07#page_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter11#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter11#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" previously published in "), _c('em', [_vm._v("The Seriously Simple Deck")]), _c('br'), _vm._v("(text copyright © 2002 by Diane Rossen Worthington and photographs copyright © 2000 by Maura McEvoy) by Chronicle Books LLC.")]), _vm._v(" "), _c('p', [_vm._v("Material on "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter08#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 20")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter10#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter12#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter14#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter16#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter16#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(", and "), _c('span', {
    attrs: {
      "href": "#/xhtml/23chapter18#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/23chapter18#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" previously published in"), _c('br'), _c('em', [_vm._v("Dad’s Awesome Grilling Book")]), _vm._v(" (text copyright © 2009 by Bob Sloan and photographs copyright © 2009 by Antonis Achilleos) by Chronicle Books LLC.")]), _vm._v(" "), _c('p', [_vm._v("Material on "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter15#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 38")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter15#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter17#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter17#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" previously published in "), _c('em', [_vm._v("Seriously Simple")]), _vm._v(" (text copyright © 2002 by Diane Rossen Worthington and photographs copyright © 2002 by Noel Barnhurst) by Chronicle Books LLC.")]), _vm._v(" "), _c('p', [_vm._v("Material on "), _c('span', {
    attrs: {
      "href": "#/xhtml/28chapter23#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 58")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/29chapter24#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" previously published in "), _c('em', [_vm._v("Tropical Cocktails Deck")]), _c('br'), _vm._v("(text and photographs copyright © 2008 by Mittie Hellmich) by Chronicle Books LLC.")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data available.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-4117-6 (hc)"), _c('br'), _vm._v("ISBN 978-1-4521-5045-1 (epub, mobi)")]), _vm._v(" "), _c('p', [_vm._v("Design by Vanessa Dina")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("www.chroniclebooks.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36177294","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03copyright.vue
// module id = 63
// module chunks = 0